import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useMachine } from '@xstate/react';
import { MAPFlowTypes } from '../../typings/deepLink';
import mainMachine from '../../machines/mainMachine';
const useMainMachine = ({ apiConfig, featureFlags, handleClose, handleCloseOnConversion, helpNumber, isOpen, additionalProps, triggerAnalyticsEvent }) => {
    const queryClient = useQueryClient();
    const mainMachineRef = useRef(mainMachine.withContext({
        apiConfig,
        conversionCount: 0,
        currentPaymentFlow: [null, null],
        featureFlags,
        handleClose,
        handleCloseOnConversion,
        helpNumber,
        queryClient,
        additionalProps,
        triggerAnalyticsEvent
    }));
    const [state, send, service] = useMachine(mainMachineRef.current, {
        devTools: process.env.NODE_ENV !== 'production'
    });
    useEffect(() => {
        if (!isOpen &&
            state.matches('open') &&
            additionalProps.flow.type !== MAPFlowTypes.MULTI_PAYMENT_FLOW) {
            send({
                type: 'CANCEL'
            });
        }
    }, [isOpen, state, send, additionalProps.flow.type]);
    return [state, send, service];
};
export default useMainMachine;
